// extracted by mini-css-extract-plugin
module.exports = {"policy__title":"policy-module__policy__title___dpuTe"};